
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/home-interior",
      function () {
        return require("private-next-pages/products/home-interior/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/home-interior"])
      });
    }
  